import accountEn from '../../../resource/locales/en/account.json';
import planEn from '../../../resource/locales/en/plan.json';
import commonEn from '../../../resource/locales/en/common.json';
import loginEn from '../../../resource/locales/en/login.json';
import homeEn from '../../../resource/locales/en/home.json';
import organizationEn from '../../../resource/locales/en/organization.json';
import userEn from '../../../resource/locales/en/userMonetic.json';
import zodEn from 'zod-i18n-map/locales/en/zod.json';
import errorsEn from '../../../resource/locales/en/errors.json';
import sessionEn from '../../../resource/locales/en/session.json';
import preLoginEn from '../../../resource/locales/en/preLogin.json';
import merchantUserEn from '../../../resource/locales/en/userMerchant.json';
import contractEn from '../../../resource/locales/en/contract.json';
import envelopeEn from '../../../resource/locales/en/envelope.json';
import subscriptionEn from '../../../resource/locales/en/subscription.json';
import terminalEn from '../../../resource/locales/en/terminal.json';
import remoteCollectionEn from '../../../resource/locales/en/remoteCollection.json';
import payluddSubscriptionEn from '../../../resource/locales/en/payludd/subscription.json';
import simCardEn from '../../../resource/locales/en/simCard.json';
import partnersEn from '../../../resource/locales/en/pushPayment/partners.json';
import notifRulesEn from '../../../resource/locales/en/pushPayment/notifRules.json';
import customizationEn from '../../../resource/locales/en/payludd/customization.json';
import searchContractEn from '../../../resource/locales/en/searchContract.json';
import dashboardEn from '../../../resource/locales/en/dashboard.json';
import historicsEn from '../../../resource/locales/en/historics.json';
import beneficiariesEn from '../../../resource/locales/en/payludd/beneficiaries.json';
import newsletterEn from '../../../resource/locales/en/nsNewsletter.json';

import accountFr from '../../../resource/locales/fr/account.json';
import planFr from '../../../resource/locales/fr/plan.json';
import commonFr from '../../../resource/locales/fr/common.json';
import loginFr from '../../../resource/locales/fr/login.json';
import homeFr from '../../../resource/locales/fr/home.json';
import organizationFr from '../../../resource/locales/fr/organization.json';
import userFr from '../../../resource/locales/fr/userMonetic.json';
import zodFr from 'zod-i18n-map/locales/fr/zod.json';
import errorsFr from '../../../resource/locales/fr/errors.json';
import sessionFr from '../../../resource/locales/fr/session.json';
import preLoginFr from '../../../resource/locales/fr/preLogin.json';
import merchantUserFr from '../../../resource/locales/fr/userMerchant.json';
import contractFr from '../../../resource/locales/fr/contract.json';
import envelopeFr from '../../../resource/locales/fr/envelope.json';
import subscriptionFr from '../../../resource/locales/fr/subscription.json';
import terminalFr from '../../../resource/locales/fr/terminal.json';
import remoteCollectionFr from '../../../resource/locales/fr/remoteCollection.json';
import payluddSubscriptionFr from '../../../resource/locales/fr/payludd/subscription.json';
import simCardFr from '../../../resource/locales/fr/simCard.json';
import partnersFr from '../../../resource/locales/fr/pushPayment/partners.json';
import notifRulesFr from '../../../resource/locales/fr/pushPayment/notifRules.json';
import customizationFr from '../../../resource/locales/fr/payludd/customization.json';
import searchContractFr from '../../../resource/locales/fr/searchContract.json';
import beneficiariesFr from '../../../resource/locales/fr/payludd/beneficiaries.json';
import dashboardFr from '../../../resource/locales/fr/dashboard.json';
import historicsFr from '../../../resource/locales/fr/historics.json';
import newsletterFr from '../../../resource/locales/fr/nsNewsletter.json';

import {
    nsAccount,
    nsBeneficiaries,
    nsContract,
    nsDashboard,
    nsCustomization,
    nsEnvelope,
    nsErrors,
    nsHistorics,
    nsHome,
    nsLogin,
    nsMerchantUser,
    nsNotifRules,
    nsOrganization,
    nsPartners,
    nsPayluddSubscription,
    nsPlan,
    nsPreLogin,
    nsRemoteCollection,
    nsSession,
    nsSimCard,
    nsSubscription,
    nsTerminal,
    nsUser,
    nsZod,
    nsSearchContract,
    nsNewsletter
} from './namespaces';

const translations = () => {
    const resources = {
        en: {
            translation: commonEn,
            [nsAccount]: accountEn,
            [nsBeneficiaries]: beneficiariesEn,
            [nsContract]: contractEn,
            [nsDashboard]: dashboardEn,
            [nsCustomization]: customizationEn,
            [nsEnvelope]: envelopeEn,
            [nsErrors]: errorsEn,
            [nsHistorics]: historicsEn,
            [nsHome]: homeEn,
            [nsLogin]: loginEn,
            [nsMerchantUser]: merchantUserEn,
            [nsNotifRules]: notifRulesEn,
            [nsOrganization]: organizationEn,
            [nsPartners]: partnersEn,
            [nsPayluddSubscription]: payluddSubscriptionEn,
            [nsPlan]: planEn,
            [nsPreLogin]: preLoginEn,
            [nsRemoteCollection]: remoteCollectionEn,
            [nsSession]: sessionEn,
            [nsSimCard]: simCardEn,
            [nsSubscription]: subscriptionEn,
            [nsTerminal]: terminalEn,
            [nsUser]: userEn,
            [nsZod]: zodEn,
            [nsSearchContract]: searchContractEn,
            [nsNewsletter]: newsletterEn
        },
        fr: {
            translation: commonFr,
            [nsAccount]: accountFr,
            [nsBeneficiaries]: beneficiariesFr,
            [nsContract]: contractFr,
            [nsDashboard]: dashboardFr,
            [nsCustomization]: customizationFr,
            [nsEnvelope]: envelopeFr,
            [nsErrors]: errorsFr,
            [nsHistorics]: historicsFr,
            [nsHome]: homeFr,
            [nsLogin]: loginFr,
            [nsMerchantUser]: merchantUserFr,
            [nsNotifRules]: notifRulesFr,
            [nsOrganization]: organizationFr,
            [nsPartners]: partnersFr,
            [nsPayluddSubscription]: payluddSubscriptionFr,
            [nsPlan]: planFr,
            [nsPreLogin]: preLoginFr,
            [nsRemoteCollection]: remoteCollectionFr,
            [nsSession]: sessionFr,
            [nsSimCard]: simCardFr,
            [nsSubscription]: subscriptionFr,
            [nsTerminal]: terminalFr,
            [nsUser]: userFr,
            [nsZod]: zodFr,
            [nsSearchContract]: searchContractFr,
            [nsNewsletter]: newsletterFr
        }
    };

    return resources;
};

export default translations;